import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-monitoring',

  templateUrl: './add-monitoring.component.html',
  styleUrl: './add-monitoring.component.css'
})
export class AddMonitoringComponent implements OnInit {
  executionFrom !: FormGroup;
  selectedDomain = 'Residential'; // default
  domainOptions:any = [];
  optionsMap: { [key: string]: any[] } = {
    domainOptionsDrp: this.domainOptions
  };

  domainFields: { [key: string]: any[] } = {
    Residential: [
      { key: "unitCompletionRate", "label": "Unit Completion Rate", "type": "number", "required": false, "value": "" },
      { key: "residentFeedbackLogs", "label": "Resident Feedback Logs", "type": "text", "required": false, "value": "" },
      { key: "safetyViolationCount", "label": "Safety Violation Count", "type": "number", "required": false, "value": "" },
    ],
    Commercial: [
      { key: "hvacPerformanceLogs", "label": "HVAC Performance Logs", "type": "text", "required": false, "value": "" },
      { key: "elevatorDowntime", "label": "Elevator Downtime", "type": "text", "required": false, "value": "" },
      { key: "fireDrillCompliance", "label": "Fire Drill Compliance", "type": "percentage", "required": false, "value": "" },
    ],
    Educational: [
      { key: "classroomReadiness", "label": "Classroom Readiness", "type": "percentage", "required": false, "value": "" },
      { key: "labEquipmentTesting", "label": "Lab Equipment Testing", "type": "text", "required": false, "value": "" },
      { key: "studentSafetyIndex", "label": "Student Safety Index", "type": "number", "required": false, "value": "" },
    ],
    Water: [
      { key: "flowRateConsistency", "label": "Flow Rate Consistency", "type": "text", "required": false, "value": "" },
      { key: "waterQualityReports", "label": "Water Quality Reports", "type": "text", "required": false, "value": "" },
      { key: "leakIncidentCount", "label": "Leak Incident Count", "type": "number", "required": false, "value": "" },
    ],
    Power: [
      { key: "voltageStabilityLogs", "label": "Voltage Stability Logs", "type": "text", "required": false, "value": "" },
      { key: "transformerLoadReport", "label": "Transformer Load Report", "type": "text", "required": false, "value": "" },
      { key: "outageFrequency", "label": "Outage Frequency", "type": "number", "required": false, "value": "" },
    ],
    Gas: [
      { key: "pressureMonitoringLogs", "label": "Pressure Monitoring Logs", "type": "text", "required": false, "value": "" },
      { key: "leakDetectionAlerts", "label": "Leak Detection Alerts", "type": "number", "required": false, "value": "" },
      { key: "safetyComplianceScore", "label": "Safety Compliance Score", "type": "percentage", "required": false, "value": "" },
    ],
    Telecom: [
      { key: "signalStrengthLogs", "label": "Signal Strength Logs", "type": "text", "required": false, "value": "" },
      { key: "downtimeIncidents", "label": "Downtime Incidents", "type": "text", "required": false, "value": "" },
      { key: "equipmentHealthIndex", "label": "Equipment Health Index", "type": "percentage", "required": false, "value": "" },
    ],
    Road: [
      { key: "surfaceConditionIndex", "label": "Surface Condition Index", "type": "number", "required": false, "value": "" },
      { key: "trafficFlowMonitoring", "label": "Traffic Flow Monitoring", "type": "text", "required": false, "value": "" },
      { key: "accidentReports", "label": "Accident Reports", "type": "number", "required": false, "value": "" },
    ],
    Consultancy: [
      { key: "monitoringReviewNotes", "label": "Monitoring Review Notes", "type": "text", "required": false, "value": "" },
      { key: "clientSatisfactionScore", "label": "Client Satisfaction Score", "type": "percentage", "required": false, "value": "" },
      { key: "riskMitigationUpdates", "label": "Risk Mitigation Updates", "type": "text", "required": false, "value": "" },
    ],
  };


  commonFields = [
    { key: "projectName", "label": "Project Name", "type": "text", "required": true, "value": "" },
    { key: "projectId", "label": "Project ID", "type": "number", "required": true, "value": "" },
    { key: "monitoringLead", "label": "Monitoring Lead", "type": "text", "required": true, "value": "" },
    { key: "monitoringStartDate", "label": "Monitoring Start Date", "type": "date", "required": true, "value": "" },
    { key: "monitoringEndDate", "label": "Monitoring End Date", "type": "date", "required": true, "value": "" },
    { key: "monitoringFrequency", "label": "Monitoring Frequency", "type": "text", "required": true, "value": "" },
    { key: "kpiMetrics", "label": "KPI Metrics", "type": "text", "required": true, "value": "" },
    { key: "reportingFormat", "label": "Reporting Format", "type": "text", "required": true, "value": "" },
    { key: "issueTrackingMethod", "label": "Issue Tracking Method", "type": "text", "required": true, "value": "" },
    { key: "complianceChecklistRef", "label": "Compliance Checklist Ref", "type": "text", "required": true, "value": "" },
    { key: 'domain', label: 'Domain', type: 'select', optionKey: 'domainOptionsDrp', required: true, value: 'Residential', onChange: (value: string) => this.onDomainChange(value) },
  ];

  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }

  ngOnInit(): void {
    this.domainOptions = Object.keys(this.domainFields).map((d) => ({ value: d, label: d }));
    this.optionsMap['domainOptionsDrp'] = this.domainOptions;
    this.executionFrom = this.fb.group({});
    this.commonFields.forEach(field => {
      const validators = field.required ? [Validators.required] : [];
      this.executionFrom.addControl(field.key, this.fb.control(field.value || '', validators));
    });
    this.onDomainChange(this.selectedDomain);
  }



  onSubmit() {
    if (this.executionFrom.valid) {
      console.log(this.executionFrom.value);
    }
  }
  onReset(): void {
    this.executionFrom.reset();
  }
  onDomainChange(domain: string) {
    this.selectedDomain = domain;
    Object.keys(this.executionFrom.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.executionFrom.removeControl(key);
      }
    });

    this.domainFields[domain].forEach(field => {
      this.executionFrom.addControl(field.key, this.fb.control(field.value));
    });

  }

}
